import axios from 'axios'

const REDIRECT_FLAG_KEY = "__RKYC_IS_REDIRECTING__";
const ACTIVITY_LISTENER_FLAG_KEY = "__RKYC_ACTIVITY_LISTENERS_ATTACHED__";
const REFRESH_INTERVAL_KEY = "__RKYC_REFRESH_INTERVAL_ID__";

let isRedirectingToLogin =
    typeof window !== 'undefined' && window[REDIRECT_FLAG_KEY] ? true : false;

// Token yenileme işlemi için promise yönetimi
let refreshTokenPromise = null;

// Build-time defaults (from env). Can be overridden at runtime via runtime-config.json.
const customConstants = {
    REFRESH_CHECK_INTERVAL: 10, // minutes - how often to check for refresh
    IDLE_THRESHOLD_FOR_REFRESH: 15, // minutes - how long idle before refresh
    SHOW_ROLE_GROUPS: true, // Set to false to hide role group selection and show individual role selection
    API_URL: process.env.REACT_APP_API_URL
        ? process.env.REACT_APP_API_URL
        : 'http://169.62.55.86:8098',
    //API_URL: (process.env.REACT_APP_API_URL) ? 'https://3d2b-78-180-114-249.ngrok-free.app' : 'https://3d2b-78-180-114-249.ngrok-free.app',
    LOGIN_URL: process.env.REACT_APP_LOGIN_URL,
    BASE_URL: process.env.REACT_APP_BASE_URL,
    AVAILABLERESULTS: [
        'AGE',
        'LIVENESSAGE',
        'FACEBLACKLISTSCORE',
        'FACELIVENESSFACECONSAVG',
        'FACELIVENESSFACECONSPER',
        'GENDER',
        'PHOTOCHEAT',
        'HOLOGRAM',
        'FACESIMILARITY',
        'FACEIMAGEAI_1',
        'FACEIMAGEAI_2',
        'MRZOCRCROSSSIMILARITY',
        'HOLOGRAMFACE',
        'HOLOGRAMIDSIMILARITY',
        'FACELIVENESS',
        'FACE',
        'HIDDENPHOTO',
        'SIGNATUREPHOTO',
        'GUILLOCHEVERIFICATION',
        'RAINBOWVERIFICATION',
        'MRZNFCSIMILARITY',
        'MRZOCRSIMILARITY',
        'NFCMRZSIMILARITY',
        'NFCOCRFACESIMILARITY',
        'NFCOCRSIMILARITY',
        'DRIVERBARCODEIDMATCH',
        'IDCARDBARCODEIDMATCH',
        'IDDOCIDMATCH',
        'IDDOCNAMEMATCH',
        'IDDOCSURNAMEMATCH',
        'LIVENESSAGE',
        'LIVENESSFACEBLACKLISTSCORE',
        'LIVENESSGENDER',
        'FACELIVENESSGESTURE',
        'MRZBIRTHDATECHECKSUM',
        'MRZEXPDATECHECKSUM',
        'MRZDOCNUMCHECKSUM',
        'MRZEXPDATECHECKSUMVALID',
        'MRZBIRTHDATECHECKSUMVALID',
        'MRZDOCNUMCHECKSUMVALID',
        'HOLOGRAMSERIALSIMILARITY',
        'HOLOGRAMBDATESIMILARITY',
        'HOLOGRAMEDATESIMILARITY',
        'AMLVALIDATION',
        'NVIPROVEIDWITHHOLDER',
        'SECONDARYIDFILE',
        'SCREENATTACK',
        'SCREENATTACKBACK',
        'SCREENATTACKFRONT',
        'SIGNATUREPHOTO',
        'OLDIDFRONT',
        'OCRLETTERCASEMATCH',
        'OCRMRZSIMILARITY',
        'OCRNFCFACESIMILARITY',
        'OCRNFCSIMILARITY',
        'OLDIDSECONDARYINFORMATION',
        'FACELIVENESSEYEMOVEMENT',
        'FACESEARCHEXISTENCE',
        'HANDLANDMARKSCORE',
        'HANDLANDMARKTYPEMATCH',
        'FACELIVENESSAI',
        'LWICONLYFRONCARDTYPESIMILARITY',
        'LWICONLYFRONTFACESIMILARITY (A-D)',
        'LWICONLYFRONTOCRSIMILARITY',
        'LWICLIVENESSAI',
        'LWICSELFIEFIRSTIDFACESIMILARITY(A-C)',
        'CHIPDETECTION',
        'PHOTOSHOPCONTROLBACK',
        'PHOTOSHOPCONTROL',
        'PHOTOSHOPCONTROL',
        'LWICONLYFRONTFACESIMILARITY',
        'LWICSELFIEFIRSTIDFACESIMILARITY',
        'FWVLIVENESS',
        'FWVLIVENESSAI',
        'FWVLIVENESSGESTURE',
        'FWVLIVENESSFACECONSAVG',
        'FWVLIVENESSFACECONSPER',
        'FWVFACE',
        'FWVAGE',
        'FWVGENDER',
        'FWVSPEECHMATCH',
        'FWVSPEECHCONSISTENCY',
        'SECURITYOBJECTVERIFICATION',
    ],
    SITE_LOGIN: true, // true for development or customer installation
    PAGE_SIZE: 50,
    // Media filter default mode for ListView filter
    // 1: Hide transactions where media and data are both empty (default legacy behavior)
    // 2: Only show transactions WITH media (onlyWithPicture = true)
    // 3: Include transactions where media and data are empty (show empties)
    INCLUDE_TX_WITHOUT_MEDIA_DEFAULT_MODE: parseInt(process.env.REACT_APP_INCLUDE_TX_WITHOUT_MEDIA_DEFAULT_MODE) || 0,
    REMEMBER_USER: true,
    ALLOW_PASTE_IN_LOGIN: process.env.REACT_APP_ALLOW_PASTE_IN_LOGIN
        ? String(process.env.REACT_APP_ALLOW_PASTE_IN_LOGIN).toLowerCase() === 'true'
        : false,
    OTP_TIMEOUT: 180,
    INCLUDE_ASSISTBOX_SDK: false,
    GTM: false,
    REDIRECT_URI : function () {
       return  this.BASE_URL + '/session/login/callback'
    },
    KEEP_MOUSE_MOVES : false,
    SCOPE: 'openid profile email',
    USE_SINGLE_SIGN_ON: process.env.REACT_APP_USE_SINGLE_SIGN_ON
        ? process.env.REACT_APP_USE_SINGLE_SIGN_ON
        : false,
    availableRoutes: [
        '/session/sign-in',
        '/session/forgot-password',
        '/session/reset-password',
        '/web-sdk/demo',
        '/web-sdk/colendi',
        '/privacy',
        '/session/mfa',
        '/session/change-password',
        '/session/create-password',
    ],
    AKSIS_URL: 'https://mediatest.proveid.io:2096',
    ASSISTBOX_URL: process.env.REACT_APP_ASSISTBOX_URL
        ? process.env.REACT_APP_ASSISTBOX_URL
        : 'https://go.assistbox.io',
    ASSISTBOX_QUEUE_SDK_URL: process.env.REACT_APP_ASSISTBOX_QUEUE_SDK_URL
        ? process.env.REACT_APP_ASSISTBOX_QUEUE_SDK_URL
        : 'https://go.assistbox.io/sdk/queueSDK/dist/assistbox-queue-sdk.min.js',
    ASSISTBOX_WEB_SDK_URL: process.env.REACT_APP_ASSISTBOX_WEB_SDK_URL
        ? process.env.REACT_APP_ASSISTBOX_WEB_SDK_URL
        : 'https://go.assistbox.io/webSDK/dist/assistbox-web-sdk.min.js',
    ASSISTBOX_RECORD_SDK_URL: process.env.REACT_APP_ASSISTBOX_RECORD_SDK_URL
        ? process.env.REACT_APP_ASSISTBOX_RECORD_SDK_URL
        : 'https://go.assistbox.io/sdk/mediaRecordSDK/dist/assistbox-media-record-sdk.min.js',
    ENABLE_GET_VC_DETAIL: process.env.REACT_APP_ENABLE_GET_VC_DETAIL === 'true' || false,
    ENABLE_SCREEN_RECORDING: process.env.REACT_APP_ENABLE_SCREEN_RECORDING !== 'false',
    AUTO_SCREEN_RECORDING: process.env.REACT_APP_AUTO_SCREEN_RECORDING !== 'false',
    SCREEN_RECORDING_ALLOWED_ORGANIZATIONS: [],
    QUALITY_MONITORING_ENABLED: true,
    QUALITY_MONITORING_RESTRICTED_TO_VC_CONTROLLER: true,
    BACKEND_LOGS_TAB_ENABLED: process.env.REACT_APP_BACKEND_LOGS_TAB_ENABLED === 'true' || false,
    ENABLE_GDPR_CHECK: process.env.REACT_APP_ENABLE_GDPR_CHECK !== 'false',
    ENABLE_HD_PHOTO: process.env.REACT_APP_ENABLE_HD_PHOTO === 'true' || false,

    // Video Call: izin verilen provider'lar env veya runtime config'den
    VIDEO_CALL_PROVIDERS: process.env.REACT_APP_VIDEO_CALL_PROVIDERS || 'assistbox,aksis',
    getVideoCallProviderOptions: () => {
        const raw = process.env.REACT_APP_VIDEO_CALL_PROVIDERS || 'assistbox,aksis'
        const list = raw.split(',').map((p) => p.trim().toLowerCase()).filter(Boolean)
        const labels = { assistbox: 'Assistbox', aksis: 'Aksis' }
        return list.map((value) => ({
            value,
            label: labels[value] || (value.charAt(0).toUpperCase() + value.slice(1)),
        }))
    },

    resolveVideoCallProvider: () => {
        const definedProvider = localStorage.getItem('videoCallProvider')
        if (definedProvider && definedProvider !== 'undefined' && definedProvider !== 'null') {
            console.log(`[Video Call Selection] Using predefined provider from user data: ${definedProvider}`)
            localStorage.setItem('videoCallAgent', definedProvider)
            return { provider: definedProvider, showDialog: false }
        }

        const options = customConstants.getVideoCallProviderOptions()
        if (options.length === 1) {
            const provider = options[0].value
            console.log(`[Video Call Selection] Using the only available provider as default: ${provider}`)
            localStorage.setItem('videoCallProvider', provider)
            localStorage.setItem('videoCallAgent', provider)
            return { provider, showDialog: false }
        } else if (options.length > 1) {
            // Need to select from multiple options
            console.log(`[Video Call Selection] Multiple providers available, showing selection dialog. Options: ${options.map(o => o.value).join(', ')}`)
            return { provider: null, showDialog: true }
        }

        console.log('[Video Call Selection] No video call providers available.')
        return { provider: null, showDialog: false }
    },
}

// Runtime config: build sonrası public/runtime-config.json varsa bu key'ler override edilir.
const RUNTIME_OVERRIDABLE_KEYS = [
    'API_URL', 'LOGIN_URL', 'BASE_URL',
    'INCLUDE_TX_WITHOUT_MEDIA_DEFAULT_MODE', 'ALLOW_PASTE_IN_LOGIN', 'USE_SINGLE_SIGN_ON',
    'ASSISTBOX_URL', 'ASSISTBOX_QUEUE_SDK_URL', 'ASSISTBOX_WEB_SDK_URL', 'ASSISTBOX_RECORD_SDK_URL',
    'ENABLE_GET_VC_DETAIL', 'ENABLE_SCREEN_RECORDING', 'AUTO_SCREEN_RECORDING',
    'BACKEND_LOGS_TAB_ENABLED', 'ENABLE_GDPR_CHECK', 'VIDEO_CALL_PROVIDERS', 'ENABLE_HD_PHOTO',
]

function coerceRuntimeValue(key, value) {
    if (value === undefined || value === null) return value
    if (key === 'INCLUDE_TX_WITHOUT_MEDIA_DEFAULT_MODE') return parseInt(value, 10)
    if (key === 'ALLOW_PASTE_IN_LOGIN' || key === 'USE_SINGLE_SIGN_ON' || key === 'ENABLE_GET_VC_DETAIL' ||
        key === 'ENABLE_SCREEN_RECORDING' || key === 'AUTO_SCREEN_RECORDING' ||
        key === 'BACKEND_LOGS_TAB_ENABLED' || key === 'ENABLE_GDPR_CHECK' || key === 'ENABLE_HD_PHOTO') {
        return typeof value === 'string' ? value.toLowerCase() === 'true' : Boolean(value)
    }
    return value
}

/**
 * Build sonrası yüklenen runtime-config.json değerlerini customConstants üzerine uygular.
 * Sadece RUNTIME_OVERRIDABLE_KEYS içindeki alanlar merge edilir.
 * @param {Object} config - runtime-config.json içeriği (kısmi olabilir)
 */
export function applyRuntimeConfig(config) {
    if (!config || typeof config !== 'object') return
    RUNTIME_OVERRIDABLE_KEYS.forEach((key) => {
        if (Object.prototype.hasOwnProperty.call(config, key)) {
            customConstants[key] = coerceRuntimeValue(key, config[key])
        }
    })
}

function redirectSigning(reason = 'unknown') {
    if (isRedirectingToLogin) {
        console.warn(`[Auth] Redirect already in progress. Suppressed duplicate redirect for reason: ${reason}`);
        return;
    }
    isRedirectingToLogin = true;
    if (typeof window !== 'undefined') {
        window[REDIRECT_FLAG_KEY] = true;
    }
    console.warn(`[Auth] Redirecting to login. Reason: ${reason}`);
    if (!customConstants.availableRoutes.includes(window.location.pathname)) {
        // Refresh interval'ı durdur
        stopRefreshInterval();
        
        axios.post(customConstants.API_URL + '/oauth/logout').then(function () {

            const hasToken = localStorage.getItem('jwt_token')
            localStorage.removeItem('auth_user')
            localStorage.removeItem('_atoken')
            localStorage.removeItem('_rtoken')
            localStorage.removeItem('grants')
            localStorage.removeItem('jwt_token')
            localStorage.removeItem('refresh_token')
            localStorage.removeItem('access_token_expires')

            axios.defaults.headers.common['Authorization'] = '';
            if (customConstants.SITE_LOGIN === false) {
                window.location = customConstants.LOGIN_URL
            } else {
                if (hasToken !== null) {
                    window.location = '/session/sign-in?timeout=true'
                } else {
                    window.location = '/session/sign-in'
                }
            }
        }).catch(function (error) {
            console.log('logout_error', error)
            window.location = '/session/sign-in?timeout=true'
        })

    
    }
}

axios.interceptors.request.use(
    async function (config) {
        // Token yenileme isteği değilse ve token yenileme işlemi devam ediyorsa bekle
        const isTokenRefreshRequest = config.url && config.url.includes('/oauth/access_token') && 
                                     config.data instanceof FormData && 
                                     config.data.has('grant_type') && 
                                     config.data.get('grant_type') === 'refresh_token';
        
        if (!isTokenRefreshRequest && refreshTokenPromise) {
            const oldToken = config.headers.Authorization || localStorage.getItem('jwt_token')
            console.log('[Token Refresh] Token yenileme işlemi devam ediyor, istek bekleniyor...', config.url)
            console.log('[Token Refresh] Giden token (eski):', oldToken ? (oldToken.substring(0, 20) + '...') : 'yok')
            await refreshTokenPromise
            // Token yenileme tamamlandıktan sonra yeni token ile Authorization header'ını güncelle
            // skipAuthInterceptor true ise Authorization header'ını yazma
            if (!config.skipAuthInterceptor) {
                const newToken = localStorage.getItem('jwt_token')
                if (newToken) {
                    const oldTokenValue = config.headers.Authorization
                    config.headers.Authorization = `Bearer ${newToken}`
                } else {
                    console.log('[Token Refresh] Token yenileme tamamlandı, ancak yeni token bulunamadı:', config.url)
                }
            }
        }

        // skipAuthInterceptor true ise Authorization header'ını yazma
        if (!config.skipAuthInterceptor) {
            const token = localStorage.getItem('jwt_token')
            if (token) {
                config.headers.Authorization = `Bearer ${token}`
            }
        }
        
    /*
        const accessTokenExpires = localStorage.getItem('access_token_expires')
        if (
            config.url &&
            !config.url.includes('access_token') &&
            accessTokenExpires &&
            +new Date() > accessTokenExpires
        ) {
            const form = new FormData()
            form.append('client_id', localStorage.getItem('client_id'))
            form.append('refresh_token', localStorage.getItem('refresh_token'))
            form.append('grant_type', 'refresh_token')

            const response = (
                await axios({
                    url: customConstants.API_URL + '/oauth/access_token',
                    method: 'POST',
                    headers: {
                        'Content-Type': `multipart/form-data; boundary=${form._boundary}`,
                    },
                    data: form,
                })
            )?.data

            config.headers.Authorization = `Bearer ${response.access_token}`

            localStorage.setItem('jwt_token', response.access_token)
            localStorage.setItem('refresh_token', response.refresh_token)
            localStorage.setItem('access_token_expires', +new Date() + response.expires_in * 1000)

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.access_token
        } */
        //console.log('axios_request', config)
        return config
    },
    function (error) {
        // Do something with request error
        // if (error && error.message) {
        //     toast.error(error.message)
        // }
        // dispatch(stopLoading())
        console.log('axios_request_error', error)
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    async function (response) {
 
        //console.log('axios_response', response)
        if (response === 'Error: Request failed with status code 401') {
            redirectSigning('axios_response_string_401')
        }

        return response
    },
    function (error) {
       
        console.log('axios_response_error', error)
        if (error?.response?.status === 401) {
            redirectSigning('axios_response_status_401')
        }

        return Promise.reject(error)
    }
)

window.axios = axios

const checkIdleAndRefreshToken = async () => {
    // refresh_token yoksa işlemi yapma
    const refreshToken = localStorage.getItem('refresh_token')
    if (!refreshToken) {
        console.log('Refresh token bulunamadı, token yenileme atlanıyor')
        return
    }

    // Eğer zaten bir token yenileme işlemi devam ediyorsa, yeni bir tane başlatma
    if (refreshTokenPromise) {
        console.log('Token yenileme işlemi zaten devam ediyor, bekleniyor...')
        await refreshTokenPromise
        return
    }

    try {
        const lastActivity = localStorage.getItem('last_activity')
        const now = +new Date()
        
        if (!lastActivity) {
            localStorage.setItem('last_activity', now)
            return
        }
 
        const idleTimeMinutes = (now - parseInt(lastActivity)) / (1000 * 60)
        
        console.log(`Idle time: ${idleTimeMinutes.toFixed(1)} minutes`)
        
   
        if (idleTimeMinutes >= customConstants.IDLE_THRESHOLD_FOR_REFRESH) {
            console.log('User has been idle for threshold time, stopping refresh attempts')
            return
        }
      
        console.log('User is active, refreshing token...')
        
        // Token yenileme işlemini başlat ve promise'i sakla
        refreshTokenPromise = (async () => {
            try {
                const oldToken = localStorage.getItem('jwt_token')
                const oldRefreshToken = localStorage.getItem('refresh_token')
                console.log('[Token Refresh] Token yenileme başlatılıyor...')
                console.log('[Token Refresh] Eski access token:', oldToken ? (oldToken.substring(0, 20) + '...') : 'yok')
                console.log('[Token Refresh] Eski refresh token:', oldRefreshToken ? (oldRefreshToken.substring(0, 20) + '...') : 'yok')
                
                const form = new FormData()
                form.append('client_id', localStorage.getItem('client_id'))
                form.append('refresh_token', oldRefreshToken)
                form.append('grant_type', 'refresh_token')

                const response = await axios({
                    url: customConstants.API_URL + '/oauth/access_token',
                    method: 'POST',
                    headers: {
                        'Content-Type': `multipart/form-data; boundary=${form._boundary}`,
                    },
                    data: form,
                })

                if (response.data) {
                    const newToken = response.data.access_token
                    const newRefreshToken = response.data.refresh_token
                    
                    console.log('[Token Refresh] Token yenileme başarılı!')
                    console.log('[Token Refresh] Eski access token:', oldToken ? (oldToken.substring(0, 20) + '...') : 'yok')
                    console.log('[Token Refresh] Yeni access token:', newToken ? (newToken.substring(0, 20) + '...') : 'yok')
                    console.log('[Token Refresh] Eski refresh token:', oldRefreshToken ? (oldRefreshToken.substring(0, 20) + '...') : 'yok')
                    console.log('[Token Refresh] Yeni refresh token:', newRefreshToken ? (newRefreshToken.substring(0, 20) + '...') : 'yok')
                    console.log('[Token Refresh] Access token yenilenen şu oldu:', newToken.substring(0, 20) + '...')
                    console.log('[Token Refresh] Refresh token yenilenen şu oldu:', newRefreshToken.substring(0, 20) + '...')
                    
                    localStorage.setItem('jwt_token', newToken)
                    localStorage.setItem('refresh_token', newRefreshToken)
                    localStorage.setItem('access_token_expires', +new Date() + response.data.expires_in * 1000)
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken
                    console.log('[Token Refresh] Token refreshed successfully for active user')
                }
            } catch (error) {
                console.error('[Token Refresh] Token yenileme hatası:', error)
                throw error
            } finally {
                // İşlem tamamlandığında promise'i temizle
                refreshTokenPromise = null
            }
        })()

        await refreshTokenPromise
    } catch (error) {
        console.error('Failed to refresh token:', error)
        refreshTokenPromise = null
        //redirectSigning('token_refresh_failed')
    }
}


const startRefreshInterval = () => {
    const refreshToken = localStorage.getItem('refresh_token')
    if (!refreshToken) {
        console.log('Refresh token bulunamadı, token yenileme atlanıyor')
        return
    } else {
        console.log('Refresh token bulundu, token yenileme başlatılıyor')
    }

    if (typeof window !== 'undefined' && window[REFRESH_INTERVAL_KEY]) {
        return;
    }
    const intervalId = setInterval(() => {
        checkIdleAndRefreshToken()
    }, customConstants.REFRESH_CHECK_INTERVAL * 60 * 1000)

    if (typeof window !== 'undefined') {
        window[REFRESH_INTERVAL_KEY] = intervalId;
    }
}

const stopRefreshInterval = () => {
    if (typeof window !== 'undefined' && window[REFRESH_INTERVAL_KEY]) {
        clearInterval(window[REFRESH_INTERVAL_KEY]);
        window[REFRESH_INTERVAL_KEY] = null;
        console.log('[Token Refresh] Refresh interval durduruldu')
    }
}

startRefreshInterval()


let activityTimer = null
const trackActivity = () => {
    localStorage.setItem('last_activity', +new Date())
    if (activityTimer) {
        clearTimeout(activityTimer)
    }

    activityTimer = setTimeout(() => {
        localStorage.setItem('last_activity', +new Date())
    }, 1000)
}

const attachActivityListeners = () => {
    if (typeof window === 'undefined') return;
    if (window[ACTIVITY_LISTENER_FLAG_KEY]) return;

    document.addEventListener('mousemove', trackActivity)
    document.addEventListener('keydown', trackActivity)
    document.addEventListener('click', trackActivity)
    document.addEventListener('scroll', trackActivity)

    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
            localStorage.setItem('last_activity', +new Date())
            console.log('Tab became active, activity tracked')
        } else {
            console.log('Tab became inactive, activity tracked')
        }
    })

    window.addEventListener('focus', () => {
        localStorage.setItem('last_activity', +new Date())
        console.log('Window gained focus, activity tracked')
    })

    window[ACTIVITY_LISTENER_FLAG_KEY] = true
}

attachActivityListeners()

localStorage.setItem('last_activity', +new Date())

// Export stopRefreshInterval for use in logout functions
export { stopRefreshInterval }

export default customConstants
